import React from "react";
import { ListItemContainer, ArrowIcon } from "../styled";
import CheckboxItem from "./CheckboxItem";

const ListItem = ({
  layer,
  layers,
  checked,
  expanded,
  checkedMap,
  expandedMap,
  onCheck,
  onExpand,
}) => {
  const subLayerIds = layer.subLayerIds;

  let subList = [];

  if (subLayerIds) {
    subLayerIds.forEach((index) => {
      const currentLayer = layers.find((l) => l.id === index);
      subList.push(
        <ListItem
          key={`layer_${currentLayer.id}`}
          layer={currentLayer}
          layers={layers}
          checked={
            checkedMap[currentLayer.id] == null
              ? true
              : checkedMap[currentLayer.id]
          }
          expanded={expandedMap[currentLayer.id]}
          checkedMap={checkedMap}
          expandedMap={expandedMap}
          onCheck={onCheck}
          onExpand={onExpand}
        />
      );
    });
  }

  return (
    <>
      <ListItemContainer>
        <CheckboxItem layer={layer} checked={checked} onClick={onCheck} />
        {subLayerIds && (
          <ArrowIcon
            className="fa-solid fa-caret-down"
            expanded={expanded}
            onClick={() => onExpand(!expanded, layer)}
          />
        )}
      </ListItemContainer>
      {expanded && <ul>{subList}</ul>}
    </>
  );
};

export default ListItem;
